'use strict';

let wakeLock = null;

//https://web.dev/blog/screen-wake-lock-supported-in-all-browsers

function requestWakeLock() {
  if ('wakeLock' in navigator) {
    navigator.wakeLock.request('screen').then(lock => {
      wakeLock = lock;
      console.log('Wake Lock is active');
      wakeLock.addEventListener('release', () => {
        console.log('Wake Lock was released');
      });
    }).catch(err => {
      console.error(`Wake Lock error: ${err.name}, ${err.message}`);
    });
  } else {
    console.warn('Wake Lock API not supported in this browser.');
  }
}

function releaseWakeLock() {
  if (wakeLock) {
    wakeLock.release().then(() => {
      console.log('Wake Lock released manually');
      wakeLock = null;
    });
  }
}

$('.recipe-steps__toggle-input').click(function () {
  if ($(this).is(':checked')) {
    $(this).addClass('is-active');
    requestWakeLock();
  } else {
    $(this).removeClass('is-active');
    releaseWakeLock();
  }
});


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/components/wakeLock.js